import React from "react";
import PropTypes from "prop-types";
import { Map } from "immutable";
import { withRouter } from "react-router";

import { dollars } from "LIB/formatters/currency";
import RecordPager from "MODULES/shared/components/RecordPager/RecordPager";
import { ClipboardCopy } from "MODULES/shared/components";
import { DESCRIPTION, PART, PART_NUMBER } from "MODULES/parts/constants";
import { SUGGESTED_RETAIL } from "MODULES/inventories/constants";
import Warnings from "../Warnings";
import InventoryDropdown from "./InventoryDropdown";
import PartLabel from "./PartLabel";

export function Header({ inventory, location }) {
  const append = location.pathname.includes("/all");
  const getUrl = (baseUrl, id) =>
    append ? `${baseUrl}/${id}/all` : `${baseUrl}/${id}`;

  return (
    <div className="page-header page-header-bar with-padding">
      <h1>
        <div className="btn-group pull-right" style={{ marginLeft: 20 }}>
          <InventoryDropdown inventory={inventory} />
        </div>
        <RecordPager
          getUrl={getUrl}
          baseUrl="/inventories"
          record={inventory}
        />
        <PartLabel part={inventory.get(PART)} />
        <ClipboardCopy name={inventory.getIn([PART, PART_NUMBER])} type="PN" />
        <span className="small text-muted">
          {inventory.getIn([PART, DESCRIPTION])}
        </span>
        <span className="pull-right">
          SRP: <span>{dollars(inventory.get(SUGGESTED_RETAIL))}</span>
        </span>
        <div className="alert-group pull-right">
          <Warnings inventory={inventory.toJS()} />
        </div>
      </h1>
    </div>
  );
}

export default withRouter(Header);

Header.propTypes = {
  inventory: PropTypes.instanceOf(Map),
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired
  }).isRequired
};



// WEBPACK FOOTER //
// ./app/modules/inventories/components/Detail/Header/Header.jsx